export default "__VITE_ASSET__2be481e2__"